















import Vue from "vue";
import CloudSettingForm from "@/components/CloudSettings/CloudSettingForm.vue";
import { CloudSettingService } from "@/services/cloudSettingService";
import { CloudSetting } from "@/models/CloudSetting";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      default: false
    },
    settingData: {
      type: Object as () => CloudSetting,
      default: null
    },
    selectedDevice: {
      type: Object as () => CloudSetting,
      default: null
    }
  },
  data() {
    return {
      modalVisible: this.value,
      saving: false
    };
  },
  components: {
    CloudSettingForm
  },
  methods: {
    async handleSubmit(data) {
      try {
        this.saving = true;
        await CloudSettingService.updateCloudSetting(this.selectedDevice.deviceUDID, data.name, data.stringValue);
        this.modalVisible = false;
        this.$emit("editSuccess");
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.saving = false;
      }
    }
  },
  watch: {
    value(newValue) {
      this.modalVisible = newValue;
    },
    modalVisible(newValue) {
      this.$emit("input", newValue);
    }
  }
});
